import {ADMIN_POINT_OF_INTEREST, PROVIDERS_ADMIN_CUSTOMER} from "../../../../../config";
import { DataTableHelper } from "../../../../../utilities/helpers/DataTableHelper";
import axios from 'axios';

export function getPointOfInterests(
	sortParam,
	pageSize,
	pageNumber,
	searchParam = '',
) {
	return axios.get(
		ADMIN_POINT_OF_INTEREST +
			( DataTableHelper.prepareParameters(
				sortParam,
				pageSize,
				pageNumber,
				null,
				searchParam
		)),
	);
}

export function createPois (objectData) {
	return axios.post(ADMIN_POINT_OF_INTEREST ,objectData);
}

export function updatePois (id, objectData) {
    return axios.put(ADMIN_POINT_OF_INTEREST + '/' + id , objectData);
}

export function getPoi (id) {
	return axios.get(ADMIN_POINT_OF_INTEREST + '/' + id);
}